var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33203L5 9.9987V33.332C5 34.2161 5.35119 35.0639 5.97631 35.6891C6.60143 36.3142 7.44928 36.6654 8.33333 36.6654H31.6667C32.5507 36.6654 33.3986 36.3142 34.0237 35.6891C34.6488 35.0639 35 34.2161 35 33.332V9.9987L30 3.33203H10Z",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10H35",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 16.668C26.6667 18.4361 25.9643 20.1318 24.7141 21.382C23.4638 22.6323 21.7682 23.3346 20 23.3346C18.2319 23.3346 16.5362 22.6323 15.286 21.382C14.0358 20.1318 13.3334 18.4361 13.3334 16.668",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopingBag);
export default __webpack_public_path__ + "static/media/shoping-bag.41129d5260eb62bd36e712a0101cb89c.svg";
export { ForwardRef as ReactComponent };